import { render, staticRenderFns } from "./ConfirmationShow.vue?vue&type=template&id=71b2e72f&scoped=true"
import script from "./ConfirmationShow.vue?vue&type=script&lang=js"
export * from "./ConfirmationShow.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationShow.vue?vue&type=style&index=0&id=71b2e72f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2e72f",
  null
  
)

export default component.exports